/**
 * función que crea un elemento HTMLElement a base de un template
 * ejemplos
 *   create(`<div>test</div>`)
 *   create(item => `<div>${item.miCampo}</div>`)
 * @param function||string el template
 * @return HTMLElement
 */

export function create(templateFnOrString) {
  const template = typeof templateFnOrString === 'function' ? templateFnOrString() : templateFnOrString,
    temp = document.createElement('div');
  temp.innerHTML = template;
  return temp.firstElementChild;
}
